import { useEffect, useState } from "react";

import { qrDataUrl } from "@/shared/utils/qrDataUrl";

/**
 * The QR of the raw address string — nothing else is encoded, so any wallet's scanner reads it as a plain
 * destination. The result is keyed by the address it was drawn from, so a new address never shows the old
 * image while the new one encodes.
 */
export function useAddressQr(address: string): { pending: boolean; src: string | null } {
  const [rendered, setRendered] = useState<{ address: string; src: string | null } | null>(null);

  useEffect(() => {
    let cancelled = false;
    void qrDataUrl(address).then((src) => {
      if (!cancelled) setRendered({ address, src });
    });
    return () => {
      cancelled = true;
    };
  }, [address]);

  const current = rendered?.address === address ? rendered : null;
  return { pending: current === null, src: current?.src ?? null };
}
